import { render, staticRenderFns } from "./process-data-node-fields.vue?vue&type=template&id=f6039a58"
import script from "./process-data-node-fields.vue?vue&type=script&lang=js"
export * from "./process-data-node-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports